import { MdOutlineImageNotSupported } from 'react-icons/md'
import { useEffect, useMemo, useRef, useState } from 'react'

import { composeClasses } from '@wiggot/utils/src/strings'

const TWICPICS_DOMAIN = process.env.TWICPICS_DOMAIN ?? ''
const IMGIX_PATH = process.env.IMGIX_PATH ?? ''
interface Props {
  src?: string
  origin?: 'imgix' | 'twicpics'
  className?: string
  width?: number
  height?: number
  dpr?: number
  q?: number
  ratio?: string
  mode?: 'cover' | 'contain'
}

const MonopolioImage = ({
  src,
  className = '',
  origin = 'imgix',
  width,
  height,
  dpr,
  q,
}: Props) => {
  const domain = IMGIX_PATH
  const twicpicsDomain = TWICPICS_DOMAIN

  const containerRef = useRef<HTMLDivElement>(null)

  const [containerWidth, setContainerWidth] = useState(0)

  const [onError, setOnError] = useState(false)

  const imgUrl = useMemo(() => {
    let url = src

    if (!url) {
      return ''
    }

    if (origin === 'twicpics') {
      const isTwp = url.includes(twicpicsDomain)
      url = url.replace(domain, '')
      return isTwp ? url : `${twicpicsDomain}/${url}`
    }

    if (!src?.includes(domain)) {
      url = `${domain}/${src}`
    }

    let query = ''

    if (width) {
      query = `?w=${width}`
    }

    if (height) {
      query = query ? `${query}&h=${height}` : `${query}?h=${height}`
    }

    if (dpr) {
      query = query ? `${query}&dpr=${dpr}` : `${query}?dpr=${dpr}`
    }

    if (q) {
      query = query ? `${query}&q=${q}` : `${query}?q=${q}`
    }

    return `${url}${query}`
  }, [src, origin, domain, width, height, dpr, q])

  useEffect(() => {
    if (!containerRef?.current) {
      return
    }

    setContainerWidth(containerRef.current.offsetWidth)
  }, [containerRef])

  return (
    <div
      className={composeClasses('w-full h-full', className)}
      ref={containerRef}
    >
      {onError || !src ? (
        <div className="w-full h-full flex justify-center items-center p-4 bg-[#EBEDF0]">
          <div>
            <div className="flex justify-center">
              <MdOutlineImageNotSupported className="w-10 h-10 fill-text-tertiary-input" />
            </div>
            {containerWidth > 250 ? (
              <div className="flex justify-center mt-2.5 max-w-[230px]">
                <p className="text-body-xs text-tertiary-input text-center">
                  Tenemos problemas para mostrar esta imagen.
                </p>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <img
          className={`w-full h-full object-cover ${className}`}
          src={imgUrl}
          alt="listing"
          onError={() => {
            setOnError(true)
          }}
          loading="lazy"
        />
      )}
    </div>
  )
}

export default MonopolioImage
